import * as React from 'react'
import { SelectCheckboxContext } from './select-checkbox-context'

export function useSelectCheckbox() {
  const context = React.useContext(SelectCheckboxContext)

  if (context === undefined) {
    throw new Error('useContext must be used within a Provider')
  }

  const { ...rest } = context

  return {
    ...rest,
  }
}
